<template>
    <div v-if="!isMobile && isUBS" class="ubs-background-wrapper" :style="ubsBackgroundStyle">
        <div class="ubs-content-left">
            <div class="ubs-hero-section">
                <img :src="logoUrl" class="ubs-logo-hero" alt="UBS" />
                <p class="ubs-hero-subtitle">Sua jornada para uma gestão patrimonial de excelência começa aqui</p>
            </div>
            
            <div class="ubs-stats-grid">
                <div class="ubs-stat-card">
                    <div class="ubs-stat-value">160+</div>
                    <div class="ubs-stat-label">Anos de história</div>
                </div>
                <div class="ubs-stat-card">
                    <div class="ubs-stat-value">50+</div>
                    <div class="ubs-stat-label">Países</div>
                </div>
                <div class="ubs-stat-card">
                    <div class="ubs-stat-value">US$5.7T</div>
                    <div class="ubs-stat-label">Ativos sob gestão</div>
                </div>
            </div>
        </div>
    </div>
    <header v-if="!isMobile && possuiLogoEsquerdaTopo" :class="{ siteHeaderRJI: isRJI, siteHeaderUBS: isUBS }" class="siteHeader">
        <div class="logo" >
            <img :src="logoUrl" :class="{ logoHeader_rji : isRJI, logoHeader: !isRJI && !isUBS, logoHeader_ubs: isUBS }"  />
        </div>
    </header>
    <div class="site-header" v-if="possuiBotaoCadastroTopo || isMobile">
        <nav class="navigation">
            <ul>
                <li>
                    <button type="button" @click="irParaCadastroInicial" class="submit-button-login">
                        Cadastro
                    </button>
                </li>
            </ul>
        </nav>
    </div>

    <div class="container"
        :class="
        { 
            containerDesktop: !isMobile && !centralizarLogin, 
            containerRJI: !isMobile && isRJI,
            containerActual: !isMobile && isActual,
            containerUBS: !isMobile && isUBS
        }"
        :style="isUBS && isMobile ? ubsBackgroundStyle : {}">

        <div v-if="!openToken" class="header">
            <div v-if="!isRJI && !isActual" class="logo">
                <img :src="logoUrl" style="width: 100%; height: 100%;" />
            </div>
            <h2 v-if="!isGenial">Selecione o tipo de conta</h2>
        </div>

        <div v-if="openToken" class="header">
            <p style="cursor: pointer; margin-top: 10px; align-self: flex-start; cursor: pointer; display: inline-flex;"
                @click="voltar()"><img src="@/assets/arrow.svg" /> Voltar</p>
            <div>
                <img src="@/assets/cadeado_com_fundo.svg" />
            </div>
            <h2 style="color: #00235C; font-size: 30px;">Chave de acesso</h2>
        </div>
        <div class="tabs-container" v-if="!openToken">
            <div class="tab-item" v-if="verificarTipoCliente('1')" :class="{ active: tab === 1 }">
                <a href="javascript:;" class="link" @click="selectTab(1)">
                    PESSOA FÍSICA
                </a>
                <div class="underline"></div>
            </div>
            <div class="tab-item" v-if="verificarTipoCliente('2')" :class="{ active: tab === 2 }">
                <a href="javascript:;" class="link" @click="selectTab(2)">
                    PESSOA JURÍDICA
                </a>
                <div class="underline"></div>
            </div>
            <div class="tab-item" v-if="verificarTipoCliente('3')" :class="{ active: tab === 3 }">
                <a href="javascript:;" class="link" @click="selectTab(3)">
                    FUNDOS
                </a>
                <div class="underline"></div>
            </div>
        </div>
        <div class="header" style="margin-top: 0; padding-top: 20px;">
            <p v-if="!openToken" style="margin-top: 0;">{{mensagemLoginHeader}}</p>

            <p v-if="openToken" style="margin-top: 0;">
            Para continuar, digite o código que acabamos de enviar para o seu e-mail.
            </p>
            <template v-if="openToken && emailProviderInfo">
            <div style="display: flex; justify-content: center; align-items: center; gap: 8px; margin-top: 8px;">
                <a
                :href="gmailMobileLink || emailProviderInfo.link"
                target="_blank"
                style="color: #6E6E6E; display: flex; align-items: center; gap: 4px; text-decoration: none;"
                >
                <img :src="emailProviderInfo.icon" :alt="emailProviderInfo.name" style="width: 22px; height: 22px; vertical-align: middle;" />
                <span style="font-size: 0.97em; font-weight: 500;">Abrir {{ emailProviderInfo.name }}</span>
                </a>
            </div>
            </template>
        </div>
        <!-- Formulário unificado para PF, PJ e Fundos -->
        <form v-if="!openToken" class="form" @submit.stop.prevent="sendLogin">
            <fieldset v-if="tab === 2 || tab === 3" :disabled="loading" style="border: none">
                <!-- Tabs 2 (PJ) e 3 (Fundos) -->
                <div class="input-field">
                    <label for="email">E-mail ou CNPJ</label>
                    <input
                        type="text"
                        v-model="loginSession.Usuario"
                        class="field"
                        autocomplete="off"
                        @click.stop.prevent="clear"
                        :ref="tab === 2 ? 'emailField2' : 'emailField3'"
                        :class="{
                            erroBorder: erro,
                            erroBorderVerifyRegister: erro && tab === 2
                        }"
                        @blur="handleEmailBlur"
                        @input="onEmailInput"
                    />
                    <ul v-if="showSuggestions && loginSession.Usuario" class="email-suggestions">
                        <li v-for="suggestion in filteredSuggestions" :key="suggestion" @mousedown.prevent="applySuggestion(suggestion)">
                            {{ loginSession.Usuario + suggestion }}
                        </li>
                    </ul>
                </div>
                <div class="input-field" v-if="configuracaoApelido == 'S'">
                    <label for="apelido">Selecione o apelido da conta para logar</label>
                    <select v-model="loginSession.Apelido" class="field" :class="{ erroBorder: erro }"
                        style="margin-bottom: 20px;" :disabled="isApelidoDisabled">
                        <option v-for="apelido in apelidos" :key="apelido" :value="apelido">{{ apelido }}</option>
                    </select>
                </div>
                <div class="input-field" v-if="modoAutenticacao != 2">
                    <label for="password">Senha</label>
                    <input type="password" v-model="loginSession.Senha" class="field" autocomplete="off"
                        @click.stop.prevent="clear" :class="{ erroBorder: erro }" />
                </div>
                <button type="button" @click="reenviarEmail" v-if="habilitarReenviarEmail"
                    class="button buttonReenviarEmail">Reenviar e-mail para ativação</button>
                <router-link class="forgot-password" v-if="modoAutenticacao != 2" to="/RecuperarSenha">Esqueci minha senha</router-link>
                <button type="submit" v-if="modoAutenticacao != 2" :disabled="disableBtnLogin"
                    :class="{ disabledBtn: disableBtnLogin }" class="submit-button-login">
                    <span class="btnText" v-if="!disableBtnLogin">Entrar</span>
                    <div class="loadingDots" v-if="disableBtnLogin">
                        <span class="dot">.</span>
                        <span class="dot2">.</span>
                        <span class="dot3">.</span>
                    </div>
                </button>
                <button type="button" @click="sendLogin()" v-if="modoAutenticacao == 2" :disabled="disableBtnLogin"
                    :class="{ disabledBtn: disableBtnLogin }" class="submit-button-login">
                    <span class="btnText" v-if="!disableBtnLogin">Avançar</span>
                    <div class="loadingDots" v-if="disableBtnLogin">
                        <span class="dot">.</span>
                        <span class="dot2">.</span>
                        <span class="dot3">.</span>
                    </div>
                </button>
            </fieldset>
            <template v-else>
                <!-- Tab 1 (PF) -->
                <div class="input-field">
                    <label for="email">E-mail ou CPF</label>
                    <input type="text" v-model="loginSession.Usuario" class="field" autocomplete="off"
                        @click.stop.prevent="clear" :class="{ erroBorder: erro }" @input="onEmailInput" ref="emailField1" />
                        <ul v-if="showSuggestions && loginSession.Usuario" class="email-suggestions">
                            <li v-for="suggestion in filteredSuggestions" :key="suggestion" @mousedown.prevent="applySuggestion(suggestion)">
                                {{ loginSession.Usuario + suggestion }}
                            </li>
                        </ul>
                
                </div>
                <div class="input-field" v-if="modoAutenticacao != 2">
                    <label for="password">Senha</label>
                    <input type="password" v-model="loginSession.Senha" class="field" autocomplete="off"
                        @click.stop.prevent="clear" :class="{ erroBorder: erro }" />
                </div>
                <button type="button" @click="reenviarEmail" v-if="habilitarReenviarEmail"
                    class="button buttonReenviarEmail">Reenviar e-mail para ativação</button>
                <router-link class="forgot-password" to="/RecuperarSenha">Esqueci minha senha</router-link>
                <button type="submit" :disabled="disableBtnLogin" :class="{ disabledBtn: disableBtnLogin }"
                    class="submit-button-login">
                    <span class="btnText" v-if="!disableBtnLogin">Entrar</span>
                    <div class="loadingDots" v-if="disableBtnLogin">
                        <span class="dot">.</span>
                        <span class="dot2">.</span>
                        <span class="dot3">.</span>
                    </div>
                </button>
            </template>
        </form>
        <form class="form" v-if="openToken" @submit.stop.prevent="sendLoginWithToken">
            <div class="input-field">

                 <div class="token-input-group">
                    <input
                    v-for="n in 6"
                    :key="n"
                    :ref="'tokenInput' + (n-1)"
                    type="text"
                    inputmode="numeric"
                    maxlength="1"
                    class="token-box"
                    :class="{ erroBorder: erro }"
                    @input="onTokenInput($event, n-1)"
                    @keydown.backspace="onTokenBackspace($event, n-1)"
                    v-model="tokenBoxes[n-1]"
                    autocomplete="one-time-code"
                    @paste="n === 1 ? onTokenPaste($event) : null"
                    />
                </div>

            </div>
            <button type="button" @click="sendLoginWithToken()" 
                :disabled="disableBtnLogin" :class="{ disabledBtn: disableBtnLogin }" class="submit-button-login">
                <span class="btnText" v-if="!disableBtnLogin">Avançar</span>
                <div class="loadingDots" v-if="disableBtnLogin">
                    <span class="dot">.</span>
                    <span class="dot2">.</span>
                    <span class="dot3">.</span>
                </div>
            </button>

            <div class="reenviar-token-wrapper" v-if="openToken">
            <button
                type="button"
                class="reenviar-token-btn"
                :disabled="!reenviarTokenDisponivel"
                @click="reenviarToken"
            >
                Reenviar token
            </button>
            <span v-if="!reenviarTokenDisponivel" class="reenviar-token-desc">
                Disponível em {{ reenviarTokenTimer }} segundos
            </span>
            </div>

        </form>
        <div class="footer" v-if="nomeEmpresa != 'GENIAL'">
            <p>Ainda não possui conta? <router-link to="/CadastroInicio">Cadastre-se</router-link></p>
        </div>
        <p>Versão {{versaoSistema}}</p>
        <ModalAvisoLogin :mensagem="messageError" :mensagensComplementares="mensagensComplementares" />
        <ModalAvisoPersonalizadoGenial v-if="nomeEmpresa == 'GENIAL' && configuracaoModalAprovacaoPersonalizada" />

    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import api from '@/api/axios';
import ModalAvisoLogin from './Login/ModalAvisoLogin.vue'
import ModalAvisoPersonalizadoGenial from './Login/ModalMensagemPersonalizadaAprovacao.vue'
import SHA256 from 'crypto-js/sha256';

// Constantes para validação
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const CNPJ_REGEX = /^(\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2})$/;
const CPF_REGEX = /^(\d{3}\.?\d{3}\.?\d{3}-?\d{2})$/;


export default {
    name: 'UserLogin',
    components: {
        ModalAvisoLogin,
        ModalAvisoPersonalizadoGenial
    },
    data() {
        return {
            tab: 1,
            loginSession: {
                Usuario: null,
                Senha: null,
                Token: null,
                Hash: null,
                Apelido: null
            },
            showSuggestions: false,
            emailSuggestions: ['@gmail.com', '@outlook.com', '@hotmail.com', '@yahoo.com'],
            filteredSuggestions: [],
            tokenBoxes: Array(6).fill(''),
            apelidos: [],
            disableBtnLogin: false,
            messageError: null,
            mensagensComplementares: false,
            erro: false,
            openToken: false,
            habilitarReenviarEmail: false,
            nomeEmpresa: '',
            loading: false,
            tiposClientes: [],
            configuracaoTiposClientes: {},
            configuracaoDuplaAutenticacao: false,
            configuracaoModalAprovacaoPersonalizada: false,
            configuracaoURLEntrar: '',
            configuracaoApelido: '',
            isApelidoDisabled: false,
            isMobile: false,
            modoAutenticacao: 0,
            reenviarTokenDisponivel: false,
            reenviarTokenTimer: 30,
            reenviarTokenInterval: null,
        };
    },
    computed: {
    gmailMobileLink() {
      if (!this.openToken || !this.emailProviderInfo) return null;
      const isGmail = this.emailProviderInfo.name === 'Gmail';
      if (!isGmail) return null;
      // Detecta se é mobile
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      const isAndroid = /android/i.test(ua);
      const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
      if (isAndroid) {
        return 'intent://#Intent;package=com.google.android.gm;scheme=mailto;end';
      }
      if (isIOS) {
        return 'googlegmail://';
      }
      return null;
    },
        emailProviderInfo() {
            const email = this.loginSession?.Usuario || '';
            const match = email.match(/@([\w.-]+)$/);
            if (!match) return null;
            const domain = match[1].toLowerCase();
            if (domain === 'gmail.com' || domain === 'dnways.com') {
                return {
                    name: 'Gmail',
                    link: 'https://mail.google.com/',
                    icon: require('@/assets/gmail.svg'), // coloque o ícone na pasta assets
                };
            }
            if (domain === 'outlook.com' || domain === 'hotmail.com' || domain === 'live.com' || domain === 'live.co.uk') {
                return {
                    name: 'Outlook',
                    link: 'https://outlook.live.com/',
                    icon: require('@/assets/outlook.svg'), // coloque o ícone na pasta assets
                };
            }
            return null;
        },
        ...mapGetters({
            getConfiguracoes: 'GET_CONFIGURACOES',
        }),
        versaoSistema(){
            return process.env.APP_VERSION ?? '';
        },
        mensagemLoginHeader(){
            return process.env.VUE_APP_MENSAGEM_LOGIN_HEADER;
        },
        possuiLogoEsquerdaTopo(){
            return process.env.VUE_APP_POSSUI_LOGO_ESQUERDA == 1 ? true : false
        },
        logoUrl() {
            return require('@/' + process.env.VUE_APP_URL_LOGO);
        },
        possuiBotaoCadastroTopo(){
            return process.env.VUE_APP_POSSUI_BOTAO_CADASTRAR_TOPO == 1 ? true : false
        },
        centralizarLogin(){
            return process.env.VUE_APP_CENTRALIZAR_LOGIN == 1 ? true : false
        },
        // Propriedades computadas para melhorar legibilidade
        isGenial() {
            return this.nomeEmpresa === 'GENIAL';
        },
        isRJI() {
            return this.nomeEmpresa === 'RJI';
        },
        isActual() {
            return this.nomeEmpresa === 'ACTUAL';
        },
        isDnwaysOrBritech() {
            return this.nomeEmpresa === 'BRITECH' || 
                  this.nomeEmpresa === 'DNWAYS_DEMO_Y' || 
                  this.nomeEmpresa === 'DNWAYS_DEMO_X';
        },
        isVortex() {
            return this.nomeEmpresa === 'Vortex';
        },
        isLastro() {
            return this.nomeEmpresa === 'Lastro';
        },
        isUBS() {
            return this.nomeEmpresa === 'UBS';
        },
        showApelidoField() {
            return this.configuracaoApelido === 'S';
        },
        activeEmailField() {
            return this.tab === 1 ? 'emailField1' : 
                   this.tab === 2 ? 'emailField2' : 'emailField3';
        },
        useDuploFator() {
            return this.configuracaoDuplaAutenticacao;
        },
        ubsBackgroundStyle() {
            if (!this.isUBS) return {};
            
            try {
                const bgImage = this.isMobile 
                    ? require('@/assets/familia.jpg')
                    : require('@/assets/montanha.jpg');
                
                return {
                    backgroundImage: `
                        linear-gradient(135deg, rgba(230, 0, 40, 0.2) 0%, rgba(168, 63, 82, 0.05) 35%, rgba(25, 25, 25, 0.8) 70%, rgba(10, 10, 10, 0.99) 100%), 
                        url(${bgImage})
                    `,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'fixed'
                };
            } catch (error) {
                return {
                    background: 'linear-gradient(135deg, #E60028 0%, #8B0018 50%, #1a1a1a 100%)'
                };
            }
        }
    },
    mounted() {
        this.disableBtnLogin = false;
        this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
        this.isMobile = window.innerWidth <= 768;
        this.tab = this.nomeEmpresa != 'GENIAL' ? 1 : 2;
        this.$store.commit('SET_MODAL_AVISO_APROVACAO_PERSONALIZADA', false)
        this.$store.commit('SET_MODAL_AVISO_LOGIN', false);
        
        // Adiciona classe ao body para UBS desktop
        if (this.isUBS && !this.isMobile) {
            document.body.classList.add('ubs-login');
        }
    },
    beforeUnmount() {
        // Remove classe ao body quando sair
        document.body.classList.remove('ubs-login');
        
        if (this.reenviarTokenInterval) {
            clearInterval(this.reenviarTokenInterval);
        }
    },
    async created() {
        await this.fetchConfiguracao(['Remover tipo de cadastro', 'Modo de autenticação', 'Modal de aprovação personalizada', 'Redirecionamento do botão entrar Onboarding externo', 'Exibir apelido']);
        this.configuracaoTiposClientes = this.getConfiguracoes('Remover tipo de cadastro');
        this.modoAutenticacao = this.getConfiguracoes('Modo de autenticação')?.Valor ?? 0;
        this.configuracaoDuplaAutenticacao = this.getConfiguracoes('Modo de autenticação')?.Valor != '0' ? true : false;
        this.configuracaoModalAprovacaoPersonalizada = this.getConfiguracoes('Modal de aprovação personalizada')?.Valor == 'S' ? true : false;
        this.configuracaoURLEntrar = this.getConfiguracoes('Redirecionamento do botão entrar Onboarding externo').Valor;
        this.configuracaoApelido = this.getConfiguracoes('Exibir apelido').Valor;
    },
    methods: {
        ...mapActions({
            signIn: 'auth/signIn',
            verifyLogin: 'auth/verifyLogin',
            verifyStatusRegister: 'auth/verifyStatusRegister',
            fetchConfiguracao: 'FETCH_CONFIGURACOES'
        }),
        onTokenPaste(e) {
        const pasted = (e.clipboardData || window.clipboardData).getData('text');
            if (pasted && pasted.length === 6 && /^\d{6}$/.test(pasted)) {
                for (let i = 0; i < 6; i++) {
                this.tokenBoxes[i] = pasted[i];
                }
                // Move o foco para o último input
                this.$nextTick(() => {
                this.$refs['tokenInput5'][0].focus();
                });
                e.preventDefault();

                setTimeout(() => {
                    this.sendLoginWithToken();
                }, 100);
                
            }
        },
        onTokenInput(e, idx) {
            const value = e.target.value.replace(/\D/g, '');
            this.tokenBoxes[idx] = value;
            if (value && idx < 5) {
                this.$refs['tokenInput' + (idx + 1)][0].focus();
            }else if(idx == 5 && value){
                this.sendLoginWithToken();
            }
        },
        onTokenBackspace(e, idx) {
            if (!this.tokenBoxes[idx] && idx > 0) {
            this.$refs['tokenInput' + (idx - 1)][0].focus();
            }
        },
        avisoLogin() {
            this.$store.commit('SET_MODAL_AVISO_LOGIN', true)
        },
        avisoLoginAprovadoPersonalizado() {
            this.$store.commit('SET_MODAL_AVISO_APROVACAO_PERSONALIZADA', true)
        },
        reenviarToken() {

            this.reenviarTokenDisponivel = false;
            this.reenviarTokenTimer = 30;
            if (this.reenviarTokenInterval) clearInterval(this.reenviarTokenInterval);
            this.reenviarTokenInterval = setInterval(() => {
                if (this.reenviarTokenTimer > 0) {
                this.reenviarTokenTimer--;
                }
                if (this.reenviarTokenTimer === 0) {
                this.reenviarTokenDisponivel = true;
                clearInterval(this.reenviarTokenInterval);
                this.reenviarTokenInterval = null;
                }
            }, 1000);
            this.sendLogin();
            this.$swal({
                icon: 'success',
                title: 'Token enviado!',
                text: 'Acesse o e-mail cadastrado para visualizar o e-mail.',
            });
        },
        voltar() {
            this.resetLoginSession();
            this.openToken = false;
        },
        resetLoginSession() {
            this.loginSession = {
                Usuario: null,
                Senha: null,
                Token: null,
                Hash: null,
                Apelido: null
            };
        },
        /**
         * Limpa mensagens de erro
         */
        clear() {
            this.messageError = '';
            this.erro = false;
        },
        async validarPreAutenticacaoModoLoginToken() {
            var model = { Usuario: this.loginSession.Usuario, Apelido: this.loginSession.Apelido, TipoCliente: this.tab }
            await this.verifyStatusRegister(model)
                .then(response => {
                    this.disableBtnLogin = false;
                    if(response.data?.data?.User.StatusCadastro == 2 && this.nomeEmpresa == 'GENIAL'){
                        this.avisoLoginAprovadoPersonalizado();
                    }
                    else if (response.data.data.User.StatusCadastro == 0 || 
                    (response.data.data.User.StatusCadastro == 2 &&  this.nomeEmpresa != 'GENIAL') ||
                    (response.data.data.User.StatusCadastro == 3 &&  this.nomeEmpresa != 'GENIAL')||
                    (response.data.data.User.StatusCadastro == 4 &&  this.nomeEmpresa != 'GENIAL'))
                    {
                        this.messageError = '';
                        this.erro = false;
                        this.openToken = true;
                    }
                })
                .catch((error) => {

                    const msgErro = error?.response?.data?.data?.erros?.[0];
                    if (msgErro === "MODAL_APROVACAO_PERSONALIZADA."&& this.nomeEmpresa == 'GENIAL') {
                        this.disableBtnLogin = false;
                        this.avisoLoginAprovadoPersonalizado();
                        return;
                    }

                    this.tratamentoErroLogin(error);
                });
        },
        verificarTipoCliente(tipo) {
            return this.tiposClientes.some(cliente => Number(cliente.value) === Number(tipo));
        },
        selectTab(index) {
            this.resetLoginSession();
            this.tab = index;
            this.$nextTick(() => {
                if (!this.isMobile) {
                    if (this.tab === 1) {
                        this.$refs.emailField1?.focus();
                    } else if (this.tab === 2) {
                        this.$refs.emailField2?.focus();
                    } else if (this.tab === 3) {
                        this.$refs.emailField3?.focus();
                    }
                }
            });
        },
        applySuggestion(suffix) {
            this.loginSession.Usuario += suffix;
            this.showSuggestions = false;
            if(this.tab != 1){
                this.handleEmailBlur();
            }
        },
        onEmailInput() {
            const val = this.loginSession.Usuario;

            const onlyNumbers = val.replace(/\D/g, '');
            // Se for só número e até 14 dígitos, aplica máscara de CNPJ
            if (/^\d+$/.test(onlyNumbers) && onlyNumbers.length > 0 && !/[a-zA-Z@]/.test(val)) {
                if(this.tab != 1){
                    this.loginSession.Usuario = this.cnpjMask(onlyNumbers);
                    if (onlyNumbers.length === 14 && this.isValidCNPJ(onlyNumbers)) {
                        this.handleEmailBlur();
                        this.focusNextField();
                    }
                }else{
                    this.loginSession.Usuario = this.cpfMask(onlyNumbers);
                    if (onlyNumbers.length === 11 && this.isValidCPF(onlyNumbers)) {
                        this.focusNextField();
                    }
                }
            } else {
            // Senão, mantém o valor original (para CPF ou e-mail)
                this.loginSession.Usuario = val;
            }

            // Regex: contém pelo menos uma letra
            const contemLetra = /[a-zA-Z]/.test(val);

            // Só sugere se contiver letra, não tiver @ e tiver pelo menos 3 caracteres
            if (contemLetra && val.length >= 3 && !val.includes('@')) {
                this.filteredSuggestions = this.emailSuggestions;
                this.showSuggestions = true;
            } else {
                this.showSuggestions = false;
            }
        },
        focusNextField() {
            // Seleciona todos os campos interativos visíveis e habilitados do formulário
            const selectors = 'input:not([disabled]):not([readonly]):not([type="hidden"]), select:not([disabled]):not([readonly]), textarea:not([disabled]):not([readonly])';
            // Se quiser limitar ao formulário atual:
            // const form = this.$el.closest('form');
            // const fields = Array.from(form.querySelectorAll(selectors));
            // Se quiser considerar toda a tela:
            const fields = Array.from(document.querySelectorAll(selectors));
            const currentIndex = fields.findIndex(field => field === document.activeElement);
            if (currentIndex !== -1 && currentIndex + 1 < fields.length) {
                fields[currentIndex + 1].focus();
            }
        },
        cnpjMask(value) {
            // value deve ser só números!
            value = value.substring(0, 14);

            if (value.length <= 2) return value;
            if (value.length <= 5) return value.replace(/^(\d{2})(\d+)/, '$1.$2');
            if (value.length <= 8) return value.replace(/^(\d{2})(\d{3})(\d+)/, '$1.$2.$3');
            if (value.length <= 12) return value.replace(/^(\d{2})(\d{3})(\d{3})(\d+)/, '$1.$2.$3/$4');
            return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2}).*/, '$1.$2.$3/$4-$5');
        },
        cpfMask(value) {
        // Remove tudo que não for número
            value = value.replace(/\D/g, '');
            // Aplica a máscara
            if (value.length <= 3) return value;
            if (value.length <= 6) return value.replace(/^(\d{3})(\d+)/, '$1.$2');
            if (value.length <= 9) return value.replace(/^(\d{3})(\d{3})(\d+)/, '$1.$2.$3');
            return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{0,2}).*/, '$1.$2.$3-$4');
        },
        isValidCPF(cpf) {
            cpf = cpf.replace(/\D/g, '');
            if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;
            let sum = 0, rest;
            for (let i = 1; i <= 9; i++) sum += parseInt(cpf.substring(i-1, i)) * (11 - i);
            rest = (sum * 10) % 11;
            if ((rest === 10) || (rest === 11)) rest = 0;
            if (rest !== parseInt(cpf.substring(9, 10))) return false;
            sum = 0;
            for (let i = 1; i <= 10; i++) sum += parseInt(cpf.substring(i-1, i)) * (12 - i);
            rest = (sum * 10) % 11;
            if ((rest === 10) || (rest === 11)) rest = 0;
            return rest === parseInt(cpf.substring(10, 11));
        },
        isValidCNPJ(cnpj) {
            cnpj = cnpj.replace(/\D/g, '');
            if (cnpj.length !== 14) return false;
            if (/^(\d)\1+$/.test(cnpj)) return false;
            let length = cnpj.length - 2;
            let numbers = cnpj.substring(0, length);
            let digits = cnpj.substring(length);
            let sum = 0;
            let pos = length - 7;
            for (let i = length; i >= 1; i--) {
                sum += numbers.charAt(length - i) * pos--;
                if (pos < 2) pos = 9;
            }
            let result = sum % 11 < 2 ? 0 : 11 - sum % 11;
            if (result !== parseInt(digits.charAt(0))) return false;
            length = length + 1;
            numbers = cnpj.substring(0, length);
            sum = 0;
            pos = length - 7;
            for (let i = length; i >= 1; i--) {
                sum += numbers.charAt(length - i) * pos--;
                if (pos < 2) pos = 9;
            }
            result = sum % 11 < 2 ? 0 : 11 - sum % 11;
            return result === parseInt(digits.charAt(1));
        },
        async handleEmailBlur() {
            if (!this.loginSession.Usuario) {
                this.apelidos = [];
                return;
            }
            this.loading = true;
            try {
                if (this.configuracaoApelido == 'S') {
                    const response = await api.get('/login', {
                        params: { chaveLogin: this.loginSession.Usuario, tipoCliente: this.tab },
                    });
                    this.apelidos = response.data.data;
                    if (this.loginSession.Usuario.includes('@')) {
                        this.loginSession.Apelido = null;
                        this.isApelidoDisabled = false;
                    } else {
                        this.loginSession.Apelido = this.apelidos.length > 0 ? this.apelidos[0] : null;
                        this.isApelidoDisabled = true;
                    }
                }
            } catch (error) {
                this.apelidos = null;

                if(error.response.data.descricao){
                    this.messageError = error.response.data.descricao;
                    this.avisoLogin();
                    this.erro = true;
                    this.disableBtnLogin = false;
                }

                console.error('Erro ao buscar apelidos:', error);
            } finally {
                this.loading = false;
            }
        },
        irParaCadastroInicial() {
            this.$router.push({ name: 'CadastroInicio' });
        },
        async reenviarEmail() {
            if (this.loginSession.Usuario == '') {
                this.messageError = 'Verifique os dados';
                this.erro = true;
                return;
            }
            var model = { Email: this.loginSession.Usuario }
            await api
                .post('/register/email-ativar-conta', model)
                .then((retorno) => {
                    if (!retorno.data) {
                        this.$swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: `Falha no envio do e-mail. Verifique as credenciais de acesso.`,
                        });
                    }
                    else {
                        this.habilitarReenviarEmail = false;
                        this.messageError = '';
                        this.erro = false;
                        this.$swal({
                            icon: 'success',
                            title: 'E-mail enviado!',
                            text: 'Acesse o e-mail cadastrado para confirmar seu acesso.',
                        }).then((result) => {
                            if (result.value) {
                                this.$router.push({ name: 'UserLogin' });
                            }
                        });
                    }
                })
                .catch((error) => {
                    this.disableBtn = false;
                    this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: `${error.response.data.descricao}`,
                    });
                });
        },
        async sendLoginWithToken() {
            this.disableBtnLogin = true;

            var model = { 
                Usuario: this.loginSession.Usuario, 
                Senha: this.loginSession.Senha ? SHA256(this.loginSession.Senha).toString() : '', 
                Token: this.loginSession.Token, 
                Apelido: this.loginSession.Apelido, 
                TipoCliente: this.tab, 
                HashToken: this.loginSession.Hash 
            }
            
            await this.signIn(model)
                .then(response => {
                    this.disableBtnLogin = false;
                    if (response.status == 200) {
                        this.messageError = '';
                        this.erro = false;
                        this.$router.replace({
                            path: '/',
                        });
                    }
                })
                .catch(() => {
                    this.disableBtnLogin = false;
                    this.erro = true;

                    this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: `O Token informado não é válido! Verifique e tente novamente.`,
                    });

                });
        },
        exibirErro(mensagem, exibirModal = true) {
            this.disableBtnLogin = false;
            this.messageError = mensagem || 'Ocorreu um erro desconhecido. Entre em contato com o suporte.';
            this.erro = true;
            if (exibirModal) {
                this.avisoLogin();
            }
            return false;
        },
       validarEntrada() {
            if (!this.loginSession.Usuario) {
                this.exibirErro(this.tab != 1 ? 'Preencha os dados de E-mail/CNPJ' : 'Preencha os dados de E-mail/CPF');
                return false;
            }
            
            if (this.modoAutenticacao == 2) {
                const usuario = this.loginSession.Usuario;
                if(this.tab != 1){
                    if (!usuario || (!EMAIL_REGEX.test(usuario) && !CNPJ_REGEX.test(usuario))) {
                        this.messageError = 'Verifique os dados';
                        this.erro = true;
                        this.disableBtnLogin = false;
                        this.exibirErro('O CNPJ/E-mail informado é inválido! Verifique os dados e tente novamente.');
                        return false;
                    }
                }else{
                    if (!usuario || (!EMAIL_REGEX.test(usuario) && !CPF_REGEX.test(usuario))) {
                        this.messageError = 'Verifique os dados';
                        this.erro = true;
                        this.disableBtnLogin = false;
                        this.exibirErro('O CPF/E-mail informado é inválido! Verifique os dados e tente novamente.');
                        return false;
                    }
                }
            }

            if ((this.loginSession.Senha == '' || this.loginSession.Senha == null) && this.modoAutenticacao != 2) {
                this.messageError = 'Preencha a senha.';
                this.avisoLogin();
                this.erro = true;
                this.disableBtnLogin = false;
                return false;
            } else if (this.configuracaoApelido == 'S' && this.tab != 1 && (this.loginSession.Apelido == '' || this.loginSession.Apelido == null)) {
                this.messageError = 'Preencha o apelido da conta';
                this.avisoLogin();
                this.erro = true;
                this.disableBtnLogin = false;
                return false;
            }

            return true;
        },
        tratamentoErroLogin(error){
            this.disableBtnLogin = false;
            var erroPrincipal = error.response.data?.data?.erros ? error.response.data?.data?.erros[0] : error.response.data.data[0];

            if(erroPrincipal == 'Cliente com e-mail não validado!'){
                this.habilitarReenviarEmail = true;
            }

            if(erroPrincipal == 'Cliente não encontrado!'){
                if(this.isGenial){
                    this.$router.push({ name: 'CadastroInicio' });
                }else{
                    this.mensagensComplementares = true;
                }
            }

            if(erroPrincipal == 'Usuário está em processo de análise.' && this.isGenial)
            {
                this.$swal({
                    icon: 'warning',
                    title: 'Cadastro enviado para análise!',
                    text: 'Estamos analisando os dados recebidos. Em breve você receberá novidades no e-mail informado.',
                });
                return;
            }

            this.messageError = erroPrincipal;
            this.avisoLogin();
            this.erro = true;
        },
        async validarPreAutenticacaoModoLoginSenhaToken(model){
                await this.verifyLogin(model)
                .then(response => {
                    this.disableBtnLogin = false;
                    if (response.data.data.Sucesso) {
                        this.messageError = '';
                        this.erro = false;
                        this.openToken = true;
                    }
                })
                .catch((error) => {
                    this.tratamentoErroLogin(error);
                });
        },
        async validarAutenticacaoSimples(model){
            await this.signIn(model)
                .then(response => {
                    this.disableBtnLogin = false;
                    if (response.status == 200) {
                        this.messageError = '';
                        this.erro = false;
                        this.$router.replace({
                            path: '/',
                        });
                    }
                })
                .catch((error) => {
                    this.tratamentoErroLogin(error);
                });
        },
        async sendLogin() {
            this.disableBtnLogin = true;
            this.habilitarReenviarEmail = false;
            this.erro = false;
            this.mensagensComplementares = false;
            
            if(!this.validarEntrada()){
                return;
            }
            
            if (this.modoAutenticacao == 2) {
                this.validarPreAutenticacaoModoLoginToken();
                return;
            }

            var model = { 
                Usuario: this.loginSession.Usuario, 
                Senha: this.loginSession.Senha ? SHA256(this.loginSession.Senha).toString() : '', 
                Apelido: this.loginSession.Apelido, 
                tipoCliente: this.tab, 
            }

            if(this.configuracaoDuplaAutenticacao){
                this.validarPreAutenticacaoModoLoginSenhaToken(model);
            }else{
                this.validarAutenticacaoSimples(model);
            }
        },
    },
    watch: {
        tokenBoxes: {
            handler(val) {
            this.loginSession.Token = val.join('');
            },
            deep: true
        },
        openToken(newVal) {
            if (newVal) {
                this.reenviarTokenDisponivel = false;
                this.reenviarTokenTimer = 30;
                if (this.reenviarTokenInterval) clearInterval(this.reenviarTokenInterval);
                this.reenviarTokenInterval = setInterval(() => {
                if (this.reenviarTokenTimer > 0) {
                    this.reenviarTokenTimer--;
                }
                if (this.reenviarTokenTimer === 0) {
                    this.reenviarTokenDisponivel = true;
                    clearInterval(this.reenviarTokenInterval);
                    this.reenviarTokenInterval = null;
                }
                }, 1000);

                this.tokenBoxes = Array(6).fill('');

            } else {
                // Limpa timer se voltar para tela anterior
                if (this.reenviarTokenInterval) {
                clearInterval(this.reenviarTokenInterval);
                this.reenviarTokenInterval = null;
                }
                this.reenviarTokenDisponivel = false;
                this.reenviarTokenTimer = 30;
            }
        },
        configuracaoTiposClientes(newVal) {
            if (newVal && newVal.Valor) {
                const valores = newVal.Valor.replace('\r\n', ';').replace(',', ';').split(';').map(item => item.trim()).filter(item => item);
                const todasOpcoes = [
                    { value: '1', label: 'Pessoa Física' },
                    { value: '2', label: 'Pessoa Jurídica' },
                    { value: '3', label: 'Fundo de Investimento' }
                ];
                const tiposFiltrados = todasOpcoes.filter(opcao => !valores.includes(opcao.value));
                if (JSON.stringify(tiposFiltrados) !== JSON.stringify(this.tiposClientes)) {
                    this.tiposClientes = tiposFiltrados;
                }
            } else {
                if (this.tiposClientes.length > 0) {
                    this.tiposClientes = [];
                }
            }
            if (this.tiposClientes.length > 0) {
                this.tab = parseInt(this.tiposClientes[0].value);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

body,
html {
    height: 100%;
    margin: 0;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
}

body.ubs-login {
    overflow: hidden;
    height: 100vh;
}

.logo {
    position: relative;
    display: inline-block;
}

.logoHeader {
    height: 100% !important;
    width: 100% !important;
    height: auto;
    display: block;
    position: relative;
    z-index: 1;
}

.logoHeader_rji {
    height: auto;
    display: block;
    position: relative;
    z-index: 1;
    height: 60% !important;
    width: 60% !important;
}

.logo-rji {
    position: relative;
    display: inline-block;
}

.logo-image-actual {
    height: 100% !important;
    width: 100% !important;
    height: auto;
    display: block;
    position: relative;
    z-index: 1;
}

@keyframes shine {
    0% {
        left: -100%;
    }

    100% {
        left: 100%;
    }
}

@keyframes shine_rji {
    0% {
        left: -100%;
    }

    100% {
        left: 50%;
    }
}

.site-header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0rem 2rem;
    background-color: #fff;
}

.token-input-group {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-bottom: 12px;
}
.token-box {
  width: 40px;
  height: 48px;
  font-size: 2rem;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 6px;
}
.token-box.erroBorder {
  border-color: red;
}

.siteHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 5em;
    padding: 0rem 2rem;
    background-color: rgba(255, 255, 255, 0.5) !important;
}

.siteHeaderRJI {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0rem 2rem;
    background-color: rgba(15, 37, 71, 0.5) !important;
}

.siteHeaderUBS {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 5em;
    padding: 0rem 2rem;
    background: linear-gradient(90deg, rgba(230, 0, 40, 0.15) 0%, rgba(0, 0, 0, 0.3) 100%);
    backdrop-filter: blur(10px);
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.2);
}

.logoHeader_ubs {
    height: 70% !important;
    width: auto !important;
    display: block;
    position: relative;
    z-index: 1;
    filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.3));
}

.reenviar-token-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 16px;
  gap: 4px;
}

.reenviar-token-btn {
  background: transparent;
  color: #00235C;
  border: none;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
  transition: color 0.2s;
  &:disabled {
    color: #aaa;
    cursor: not-allowed;
    text-decoration: none;
  }
}

.reenviar-token-desc {
  color: #888;
  font-size: 0.95rem;
  margin-top: 2px;
}

.siteHeaderActual {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.logo img {
    height: 32px;
    width: 142px;
}

.navigation ul {
    list-style: none;
    display: flex;
    gap: 1rem;
}

.submit-button-login {
    width: 100%;
    padding: 0.5rem;
    color: white;
    border: none;
    cursor: pointer;
    background: #03204f;
    text-align: center;
    border: 1px solid #5E84C3;
    border-radius: 8px;
}

.navigation li {
    padding: 0.5rem 1rem;
}

.navigation a {
    text-decoration: none;
    color: #000;
}

.navigation a.router-link-active {
    color: #00235C;
}

.buttonReenviarEmail {
    cursor: pointer;
    margin-bottom: 10px;
}

.navigation a.router-link-exact-active {
    background-color: #00235C;
    color: #fff;
    border-radius: 5px;
    padding: 0.5rem 1rem;
}

.email-suggestions {
  position: absolute;
  background: white;
  z-index: 100;
  list-style: none;
  margin: 0;
  margin-top: -20px;
  padding: 0;
  border-radius: 8px;
  border: 1px solid #d0d5dd;
}
.email-suggestions li {
  padding: 6px 12px;
  cursor: pointer;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  border-bottom: 1px solid #d0d5dd;
  color: #03204f;
}
.email-suggestions li:hover {
  background: #03204f;
  color: white;
}

.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    padding-top: 0px;
    border-radius: 10px;
    background-color: white;
    border-radius: 8px;
}

.containerDesktop {
    background-color: rgba(255, 255, 255, 0.5) !important;
    padding-top: 3em;
    height: 100vh;
    width: 30vw;
    position: absolute;
    top: 0;
    right: 0;
}

.containerActual {
    background-color: rgba(37, 36, 87, 0.5) !important;
    color: #FFF;
    height: 100vh;
    width: 30vw;
    position: absolute;
    top: 0;
    right: 0;

    .forgot-password{
        color: rgba(37, 36, 87, 0.5) !important;
        cursor: pointer !important;
    }
}

.containerRJI {
    background-color: rgba(15, 37, 71, 0.5) !important;
    color: #FFF;
    height: 100vh;
    width: 30vw;
    position: absolute;
    top: 0;
    right: 0;
}

.containerRJI h2 {
    color: #FFF !important;
}

.containerRJI p {
    color: #FFF !important;
}

.containerRJI label {
    color: #00235C !important;
}

.containerRJI .forgot-password {
    color: #00235C !important;
    font-weight: 800;
}

.containerRJI .link{
    color: #FFF !important;
}

.containerRJI .tab-item{
    color: #FFF !important;
    font-weight: 800;
}

.containerRJI .footer a{
   color: #FFF !important;
}

.containerActual h2 {
    color: #FFF !important;
}

.containerActual p {
    color: #FFF !important;
}


.containerActual  a {
    color: #FFF !important;
    font-weight: 800;
}

.logomark {
    width: 54px;
    height: 43.2px;
}

.header {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;


}

p{
    font-family: "Inter", sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    text-align: center;
    color: #6E6E6E;
}

.header h2 {
    width: 360px;
    height: 38px;
    font-family: 'Gabarito', sans-serif;
    font-weight: 600;
    font-size: 30px;
    line-height: 38px;
    text-align: center;
    margin: 0 auto;
    color: #101828;
    margin-top: 20px;
}

.header p {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #6E6E6E;
}

.footer p {
    font-family: 'Inter', sans-serif;
    color: #667085;
    font-size: 16px;
    line-height: 24px;
}

.footer a {
    font-weight: 600;
    color: #101828;
    text-decoration: none;
}

button {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0;
    text-align: left;
}

.entrar-button {
    color: #667085;
    background: white;
    cursor: pointer;
}

input {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    padding: 10px;
    margin-bottom: 16px;
    border: 1px solid #ccc;
    border-radius: 8px;
    box-sizing: border-box;
    width: 100%;
}

.erroBorder {
    border: 1px solid #E73D3D !important;
    margin-bottom: 16px;
}

.erroBorderVerifyRegister {
    border: 1px solid #E73D3D !important;
    margin-bottom: 10px;
}

.erro {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    margin-top: 0px;
    color: #E73D3D;
    max-width: 360px;
}

.form .input-field label {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #344054;
}

form {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    background-color: #f5f5f5;
    padding: 20px;
    border-radius: 8px;
    width: calc(130px * 3 + 40px * 2);
}

input {
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

button {
    padding: 10px;
    background-color: #00235C;
    ;
    color: white;
    border: none;
    border-radius: 4px;
    text-align: center;
}

@media (max-width: 600px) {
    .login-container {
        margin: 20px;
        padding: 10px;
    }

    input,
    button {
        margin-bottom: 10px;
    }
}

h2 {
    text-align: center;
    margin-bottom: 20px;
}

.forgot-password {
    font-family: 'Inter', sans-serif;
    display: block;
    text-align: center;
    margin-bottom: 20px;
    font-weight: 600;
    color: #00064F;
    text-decoration: none;
}

.signup {
    text-align: center;
    margin-top: 20px;
}

.signup a {
    color: blue;
    text-decoration: none;
}

.tabs-container {
    display: flex;
    justify-content: center;
    position: relative;
    border-bottom: 2px solid #D3D3D3;
}

.tab-item {
    position: relative;
    min-width: 130px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-left: 20px;
}

.tab-item .link {
    display: inline-block;
    padding: 10px;
    color: rgb(1, 1, 68);
    text-decoration: none;
    margin-left: 18px;
    font-weight: bold;
    width: 100%;
}

.tab-item .underline {
    position: absolute;
    bottom: -2px;
    left: 0;
    right: 0;
    height: 2px;
    background-color: transparent;
    transition: background-color 0.3s;
}

.tab-item.active .link {
    color: rgb(1, 1, 68);
}

.tab-item.active .underline {
    background-color: rgb(1, 1, 68);
    margin-left: -18px;
}

/* UBS Background Wrapper */
.ubs-background-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 0;
    overflow: hidden;
}

.ubs-background-wrapper::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 50%, rgba(230, 0, 40, 0.15) 0%, transparent 50%);
    pointer-events: none;
}

/* UBS Content Left Side - Modern Design */
.ubs-content-left {
    position: absolute;
    left: 0;
    top: 0;
    width: calc(100vw - 560px);
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 80px;
    gap: 50px;
    z-index: 1;
}

.ubs-hero-section {
    animation: ubsFadeIn 1s cubic-bezier(0.16, 1, 0.3, 1);
}

.ubs-logo-hero {
    width: 120px;
    height: auto;
    filter: brightness(0) invert(1) drop-shadow(0 2px 16px rgba(0, 0, 0, 0.2));
    margin-bottom: 60px;
    opacity: 1;
}

.ubs-hero-title {
    font-size: 52px;
    font-weight: 300;
    color: #fff;
    margin: 0 0 20px 0;
    letter-spacing: -1.5px;
    line-height: 1.1;
    text-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
}

.ubs-hero-subtitle {
    font-size: 16px;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.8);
    margin: 0;
    line-height: 1.65;
    max-width: 380px;
    text-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);
}

.ubs-stats-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    max-width: 520px;
    animation: ubsSlideIn 1s cubic-bezier(0.16, 1, 0.3, 1);
    animation-delay: 0.3s;
    animation-fill-mode: both;
}

.ubs-stat-card {
    background: rgba(255, 255, 255, 0.06);
    backdrop-filter: blur(30px) saturate(180%);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 20px 16px;
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    cursor: default;
    position: relative;
    overflow: hidden;
}

.ubs-stat-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, transparent 100%);
    opacity: 0;
    transition: opacity 0.3s ease;
}

.ubs-stat-card:hover {
    transform: translateY(-2px);
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.2);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
}

.ubs-stat-card:hover::before {
    opacity: 1;
}

.ubs-stat-value {
    font-size: 28px;
    font-weight: 600;
    color: #fff;
    margin-bottom: 6px;
    text-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);
    letter-spacing: -0.5px;
}

.ubs-stat-label {
    font-size: 11px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.65);
    text-transform: uppercase;
    letter-spacing: 0.8px;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    line-height: 1.4;
}

/* Responsive adjustments */
@media (max-width: 1440px) {
    .ubs-content-left {
        width: calc(100vw - 520px);
        padding: 60px;
        gap: 45px;
    }
    
    .ubs-hero-title {
        font-size: 48px;
    }
    
    .ubs-hero-subtitle {
        font-size: 15px;
    }
    
    .ubs-stat-value {
        font-size: 26px;
    }
    
    .ubs-stat-card {
        padding: 18px 14px;
    }
}

@media (max-width: 1024px) {
    .ubs-content-left {
        width: calc(100vw - 480px);
        padding: 50px;
        gap: 35px;
    }
    
    .ubs-logo-hero {
        width: 100px;
        margin-bottom: 40px;
    }
    
    .ubs-hero-title {
        font-size: 42px;
    }
    
    .ubs-hero-subtitle {
        font-size: 14px;
    }
    
    .ubs-stats-grid {
        gap: 12px;
    }
    
    .ubs-stat-card {
        padding: 16px 12px;
    }
    
    .ubs-stat-value {
        font-size: 22px;
    }
    
    .ubs-stat-label {
        font-size: 10px;
    }
}

/* UBS Custom Styling */
.containerUBS {
    color: #FFF;
    height: 100vh;
    width: 560px;
    max-width: 90vw;
    position: fixed;
    top: 0;
    right: 0;
    background: linear-gradient(to left, 
        rgba(255, 255, 255, 0.98) 0%, 
        rgba(252, 252, 252, 0.97) 100%
    );
    box-shadow: 
        -40px 0 100px rgba(0, 0, 0, 0.35),
        -20px 0 60px rgba(230, 0, 40, 0.08),
        0 0 0 1px rgba(0, 0, 0, 0.05);
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 30px 45px;
    padding-top: 30px;
    backdrop-filter: blur(30px) saturate(180%);
    z-index: 1;
}

.containerUBS::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: linear-gradient(180deg, 
        #E60028 0%, 
        #C7001F 25%,
        #8B0018 50%, 
        #C7001F 75%,
        #E60028 100%
    );
    z-index: 10;
    box-shadow: 
        3px 0 20px rgba(230, 0, 40, 0.6),
        1px 0 8px rgba(230, 0, 40, 0.4);
    animation: ubsGlow 4s ease-in-out infinite;
}

@keyframes ubsGlow {
    0%, 100% {
        opacity: 0.9;
        box-shadow: 
            3px 0 20px rgba(230, 0, 40, 0.6),
            1px 0 8px rgba(230, 0, 40, 0.4);
    }
    50% {
        opacity: 1;
        box-shadow: 
            3px 0 25px rgba(230, 0, 40, 0.8),
            1px 0 12px rgba(230, 0, 40, 0.6);
    }
}

.containerUBS .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 12px;
}

.containerUBS h2 {
    color: #0a0a0a !important;
    text-shadow: none;
    font-size: 24px !important;
    font-weight: 600 !important;
    letter-spacing: -0.6px;
    margin-bottom: 8px !important;
    margin-top: 0 !important;
    line-height: 1.3 !important;
}

.containerUBS p {
    color: #5a5a5a !important;
    text-shadow: none;
    font-size: 13px !important;
    line-height: 1.5 !important;
    font-weight: 400 !important;
    margin-bottom: 8px !important;
}

.containerUBS label {
    color: #2a2a2a !important;
    font-weight: 600 !important;
    text-shadow: none;
    font-size: 12px !important;
    letter-spacing: 0.3px;
    text-transform: uppercase;
}

.containerUBS .form {
    background: transparent !important;
    box-shadow: none;
    border: none;
    padding: 0 !important;
    margin-top: 16px;
}

.containerUBS .form label {
    color: #2a2a2a !important;
    text-shadow: none;
    margin-bottom: 5px;
    display: block;
}

.containerUBS .forgot-password {
    color: #E60028 !important;
    font-weight: 600 !important;
    text-shadow: none;
    transition: all 0.2s ease;
    font-size: 13px !important;
    letter-spacing: 0.2px;
    position: relative;
    margin-bottom: 6px !important;
}

.containerUBS .forgot-password::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 0;
    height: 1.5px;
    background: #E60028;
    transition: width 0.3s ease;
}

.containerUBS .forgot-password:hover {
    color: #c7001f !important;
}

.containerUBS .forgot-password:hover::after {
    width: 100%;
}

.containerUBS .submit-button-login {
    background: linear-gradient(135deg, #E60028 0%, #C7001F 100%) !important;
    border: none !important;
    box-shadow: 
        0 4px 14px rgba(230, 0, 40, 0.35),
        0 2px 6px rgba(230, 0, 40, 0.25),
        inset 0 1px 0 rgba(255, 255, 255, 0.15);
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    font-weight: 600 !important;
    font-size: 14px !important;
    padding: 12px 20px !important;
    border-radius: 8px !important;
    margin-top: 8px !important;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    position: relative;
    overflow: hidden;
}

.containerUBS .submit-button-login::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.6s ease;
}

.containerUBS .submit-button-login:hover::before {
    left: 100%;
}

.containerUBS .submit-button-login:hover {
    background: linear-gradient(135deg, #FF0530 0%, #D8002A 100%) !important;
    box-shadow: 
        0 6px 20px rgba(230, 0, 40, 0.45),
        0 3px 10px rgba(230, 0, 40, 0.35),
        inset 0 1px 0 rgba(255, 255, 255, 0.2);
    transform: translateY(-2px);
}

.containerUBS .submit-button-login:active {
    transform: translateY(0);
    box-shadow: 
        0 2px 8px rgba(230, 0, 40, 0.35),
        0 1px 4px rgba(230, 0, 40, 0.25);
}

.containerUBS .tabs-container {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
    margin-bottom: 0 !important;
}

.containerUBS .link {
    color: #5a5a5a !important;
    font-weight: 600;
    text-shadow: none;
    font-size: 12px !important;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    transition: color 0.2s ease;
}

.containerUBS .tab-item {
    color: #5a5a5a !important;
    font-weight: 600;
    transition: all 0.2s ease;
}

.containerUBS .tab-item:hover .link {
    color: #2a2a2a !important;
}

.containerUBS .tab-item.active .link {
    color: #E60028 !important;
}

.containerUBS .tab-item.active .underline {
    background-color: #E60028 !important;
    height: 2px;
    box-shadow: 0 2px 8px rgba(230, 0, 40, 0.3);
}

.containerUBS .footer {
    margin-top: 16px;
    padding-top: 14px;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.containerUBS .footer p {
    color: #5a5a5a !important;
    font-size: 12px !important;
}

.containerUBS .footer a {
    color: #E60028 !important;
    font-weight: 600;
    text-shadow: none;
    transition: all 0.2s ease;
    position: relative;
}

.containerUBS .footer a::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 0;
    height: 1.5px;
    background: #E60028;
    transition: width 0.3s ease;
}

.containerUBS .footer a:hover {
    color: #c7001f !important;
}

.containerUBS .footer a:hover::after {
    width: 100%;
}

.containerUBS .header .logo {
    background: transparent;
    padding: 0;
    border-radius: 0;
    box-shadow: none;
    backdrop-filter: none;
    margin-bottom: 12px;
    display: inline-block;
    max-width: 90px;
    transition: transform 0.3s ease;
}

.containerUBS .header .logo img {
    width: 100%;
    height: auto;
    display: block;
}

.containerUBS .logo:hover {
    transform: scale(1.02);
}

.containerUBS .logo img {
    width: 100%;
    height: auto;
    filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.08));
}

/* UBS Input Styling */
.containerUBS .field {
    border: 1.5px solid #e0e0e0 !important;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    background: #fff !important;
    color: #0a0a0a !important;
    font-size: 14px !important;
    padding: 11px 13px !important;
    border-radius: 6px !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.containerUBS .field:hover {
    border-color: #d0d0d0 !important;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

.containerUBS .field:focus {
    border-color: #E60028 !important;
    box-shadow: 
        0 0 0 4px rgba(230, 0, 40, 0.08),
        0 2px 8px rgba(230, 0, 40, 0.12) !important;
    outline: none !important;
    transform: translateY(-1px);
}

.containerUBS .field::placeholder {
    color: #999;
    font-weight: 400;
}


.containerUBS .token-box {
    border: 1.5px solid #e0e0e0 !important;
    font-weight: 600;
    color: #0a0a0a !important;
    background: #fff !important;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.containerUBS .token-box:hover {
    border-color: #d0d0d0 !important;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

.containerUBS .token-box:focus {
    border-color: #E60028 !important;
    box-shadow: 
        0 0 0 4px rgba(230, 0, 40, 0.08),
        0 2px 8px rgba(230, 0, 40, 0.12) !important;
    outline: none !important;
    transform: scale(1.05);
}

.containerUBS select {
    border: 1.5px solid #e0e0e0 !important;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    background: #fff !important;
    color: #0a0a0a !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.containerUBS select:hover {
    border-color: #d0d0d0 !important;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

.containerUBS select:focus {
    border-color: #E60028 !important;
    box-shadow: 
        0 0 0 4px rgba(230, 0, 40, 0.08),
        0 2px 8px rgba(230, 0, 40, 0.12) !important;
    outline: none !important;
}

.containerUBS .input-field {
    margin-bottom: 10px;
}

/* UBS Animations */
@keyframes ubsFadeIn {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes ubsSlideIn {
    from {
        opacity: 0;
        transform: translateX(30px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.containerUBS .form {
    animation: ubsFadeIn 0.7s cubic-bezier(0.4, 0, 0.2, 1) 0.1s both;
}

.containerUBS .header {
    animation: ubsFadeIn 0.7s cubic-bezier(0.4, 0, 0.2, 1) both;
}

.containerUBS .logo {
    animation: ubsSlideIn 0.8s cubic-bezier(0.4, 0, 0.2, 1) both;
}

/* UBS Mobile Styling */
@media (max-width: 768px) {
    .containerUBS {
        width: 100vw;
        max-width: 100vw;
        padding: 30px 24px;
    }
    
    .containerUBS h2 {
        font-size: 24px !important;
    }
    
    .containerUBS .logo {
        max-width: 120px;
        margin-bottom: 28px;
    }
    
    .containerUBS .submit-button-login {
        padding: 12px 18px !important;
        font-size: 13px !important;
    }
}

/* UBS Tablets */
@media (min-width: 769px) and (max-width: 1024px) {
    .containerUBS {
        width: 440px;
        padding: 50px 40px;
    }
}

/* UBS Desktop Medium */
@media (min-width: 1025px) and (max-width: 1440px) {
    .containerUBS {
        width: 480px;
    }
}

/* UBS Desktop Large Screen */
@media (min-width: 1441px) {
    .containerUBS {
        width: 520px;
        padding: 50px 55px;
    }
    
    .containerUBS h2 {
        font-size: 28px !important;
    }
    
    .containerUBS .field {
        padding: 12px 14px !important;
        font-size: 15px !important;
    }
}
</style>
